import { HttpContextToken } from '@angular/common/http';

export const BYPASS_RECAPTCHA_SESSION = new HttpContextToken<boolean>(() => false);
